import { Sheet, SheetContent } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';

interface GuestGateModalProps {
  visible: boolean;
  onClose: () => void;
  onLogin: () => void;
  actionLabel: string;
}

export function GuestGateModal({ visible, onClose, onLogin, actionLabel }: GuestGateModalProps) {
  return (
    <Sheet open={visible} onOpenChange={(open) => { if (!open) onClose(); }}>
      <SheetContent side="bottom" className="rounded-t-2xl pb-8">
        {/* Brand gradient accent bar */}
        <div className="w-12 h-1.5 mx-auto rounded-full bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 mb-6" />

        <div className="text-center space-y-3 px-2">
          <h2 className="text-xl font-bold">Sign up to continue 🏘️</h2>
          <p className="text-muted-foreground text-sm leading-relaxed">
            You need to join as a neighbor to {actionLabel}.{'\n'}
            Sign up to freely use your local flea market!
          </p>
        </div>

        <div className="mt-6 space-y-3">
          <Button
            onClick={onLogin}
            className="w-full bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 text-white border-0 hover:opacity-90"
          >
            Sign Up / Log In
          </Button>
          <Button
            variant="ghost"
            onClick={onClose}
            className="w-full text-muted-foreground"
          >
            Later
          </Button>
        </div>
      </SheetContent>
    </Sheet>
  );
}
